// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-list[data-v-555653fd]{padding-left:15px;margin:20px 0 0 10px}.icon-list__item[data-v-555653fd]{list-style:initial;display:flex;align-items:center;margin-bottom:10px}.icon-list__item[data-v-555653fd]:last-child{margin:0}.icon-list__icon[data-v-555653fd]{color:#4fc08d;margin-right:10px}.icon-list__content[data-v-555653fd]{display:block}.icon-list__link[data-v-555653fd]:hover{color:#e2401c}", ""]);
// Exports
module.exports = exports;
